/*
 * MutationObserver that detects when any elements are added to the Body
 */
site.ada.bodyObserver = () => {
    const targetNode = document.querySelector('body');
    const config = { childList: true, subtree: true };

    bodyMutObserver = new MutationObserver(function (mutations_list) {
        mutations_list.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (addedNode) {
                // If the Klaviyo Popup is loaded, run the ADA fixes.
                if (addedNode && 
                    addedNode.querySelector && 
                    addedNode.querySelector('[class^="kl-private-reset-css"]')) {
                    site.ada.klaviyoPopupAdaFixes();
                    bodyMutObserver.disconnect();
                }
                // Add additional 3rd party app fixes here, if needed
            });
        });
    });
    bodyMutObserver.observe(targetNode, config);
}

// Klaviyo Popup ADA Fixes
site.ada.klaviyoPopupAdaFixes = () => {
    const klavDropdownBtnCls = '#downshift-0-toggle-button';

    // The Klaviyo popup child elements may load in after the initial wrapper
    // So we need to run the site.ada.elementTimer function to catch them.
    site.ada.elementTimer(klavDropdownBtnCls, function (elements) {
        Array.from(elements).forEach(element => {
            element.setAttribute('aria-hidden', 'true');
        })
    })

    // Remove decorative alt text from images in the Klaviyo popup
    // We can't do this in Klaviyo since it removes alt all together when empty, so we have to do it here.
    // Add any decorative alt text to the decorativeAltTextArray and it will be removed.
    const decorativeAltTextArray = ['heart'];
    site.ada.elementTimer('img', function (elements) {
        Array.from(elements).forEach(element => {
            // if the image has an alt attribute that is in decorativeAltTextArray, set it to empty string
            if (element.alt && decorativeAltTextArray.includes(element.alt.toLowerCase())) {
                element.alt = '';
            }
        })
    })
}

// Event listeners
window.addEventListener('DOMContentLoaded', event => {
    site.ada.bodyObserver();
});